import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

type EarnedCreditsLog = {
  type: string;
  referee_email?: string;
  booking_id?: number;
  booking_link?: string;
  amount: number;
  created?: string;
};

type EarnedCreditsResponse = {
  available_credits: number;
  logs: EarnedCreditsLog[];
};

export const useEarnedCredits = () => {
  return useSWR(`${getCoreApi()}/statistics/earned-credits`, url =>
    apiRequest<EarnedCreditsResponse>({ url }, true),
  );
};
